import axios from 'axios';
import has from "lodash/has";
import { push } from 'connected-react-router';
import { SubmissionError } from "redux-form";
import { authHeader } from "helpers/authHeader";

//import { fetchLoanApplication } from "actions/app";

export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';

const loginRequest = () => ({
    type: LOGIN_REQUEST
});

export const loginSuccess = (payload) => ({
    type: LOGIN_SUCCESS,
    payload
});

const loginFailure = (payload) => ({
    type: LOGIN_FAILURE,
    payload
});

export const getUserDestination = () => (dispatch, getState) => {
	
	const state = getState();
	const  { businessInfo, loanApplication } = state.app;
	
	if(!loanApplication || !loanApplication.didShortForm){
			return dispatch(push('/application/initial-info'));
	} else {
		// get Business Info response
		if ( !businessInfo || !businessInfo.legalEntityType ) {
			// Send to first step
			return dispatch(push('/application/business'));
		} else if ( businessInfo.owners.length === 0 ) {
			// Send to second step
			return dispatch(push('/application/owners'));
		} else if ( loanApplication.status === 1 ) {	//Status = "Review"
				// Send to last step
				return dispatch(push('/application/success'));
		} else {
			if ( loanApplication.statements.length === 0 ) {
				return dispatch(push('/application/loan'));
			} else {
				return dispatch(push('/application/review'))
			}
		}
	}
};

export const loginUser = (creds) => dispatch => {
    dispatch(loginRequest());
    return axios.post('/login', {
        ...creds
    })
    .then( response => {
        // login successful if there's a jwt token in the response
        if (response.data.token) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('e_3235', JSON.stringify(response.data.token));
            dispatch(loginSuccess(response.data));            
        }
        return response.data;
    })
    .catch( error => {

        if ( has(error, 'response.data.message') ) {
            dispatch(loginFailure(error.response.data));
            throw new SubmissionError({
                email: true,
                password: true,
                _error: error.response.data.message
            });
        } else {
            const errorMsg = 'An unexepected error has occured. Please try again';
            dispatch(loginFailure(errorMsg));
            throw new SubmissionError({
                email: true,
                password: true,
                _error: errorMsg
            });
        }

    })
};

export const SIGNUP_REQUEST = 'SIGNUP_REQUEST';
export const SIGNUP_SUCCESS = 'SIGNUP_SUCCESS';
export const SIGNUP_FAILURE = 'SIGNUP_FAILURE';

const signupRequest = () => ({
    type: SIGNUP_REQUEST
});

const signupSuccess = (payload) => ({
    type: SIGNUP_SUCCESS,
    payload
});

const signupFailure = (payload) => ({
    type: SIGNUP_FAILURE,
    payload
});

export const signupUser = (creds) => dispatch => {
    dispatch(signupRequest());
    return axios('/customer', {
        method: 'POST',
        data: creds,
    })
    .then( response => {
        // login successful if there's a jwt token in the response
        if (response.data.token) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('e_3235', JSON.stringify(response.data.token));
        }
        dispatch(signupSuccess(response.data));
        return creds.email;
    })
    .catch( error => {
        const { data } = error.response;
        dispatch(signupFailure(data));
        if (data.hasOwnProperty('error_code')) {
            if ( data.error_code === 'ALREADY_EXISTS' ) {
                throw new SubmissionError({
                    email: data.message
                })
            }
        } else {
            throw new SubmissionError({
                _error: data.message
            })
        }
        return data
    })
};


export const LOGIN_QUICKBOOKS_REQUEST = "LOGIN_QUICKBOOKS_REQUEST";
export const LOGIN_QUICKBOOKS_SUCCESS = "LOGIN_QUICKBOOKS_SUCCESS";
export const LOGIN_QUICKBOOKS_FAILURE = "LOGIN_QUICKBOOKS_FAILURE";

const loginWithQuickbooksRequest = () => ({
    type: LOGIN_QUICKBOOKS_REQUEST
});

const loginWithQuickbooksFailure = (payload) => ({
    type: LOGIN_QUICKBOOKS_FAILURE,
    payload
});

const loginWithQuickbooksSuccess = (payload) => ({
    type: LOGIN_QUICKBOOKS_SUCCESS,
    payload
});

export const loginWithQuickbooks = (code, realmId, redirectUri, utmTags) => dispatch => {
    dispatch(loginWithQuickbooksRequest());
    return axios.post(`/login/quickbooks`, {
        code,
        realmId,
        redirectUri,
		...utmTags
    }).then((response) => {
        if (response.data.token) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('e_3235', JSON.stringify(response.data.token));
            dispatch(getUserDestination())
                .then(() => dispatch(loginWithQuickbooksSuccess(response.data)));
        }
        return response.data;
    }).catch(error => {
        dispatch(loginWithQuickbooksFailure(error.response));
        return error.response.data;
    })

};

export const LOGOUT_REQUEST = "LOGOUT_REQUEST";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const LOGOUT_FAILURE = "LOGOUT_FAILURE";

export const logoutRequest = () => ({
    type: LOGOUT_REQUEST
});

const logoutFailure = (payload) => ({
    type: LOGOUT_FAILURE,
    payload
});

const logoutSuccess = (payload) => ({
    type: LOGOUT_SUCCESS,
    payload
});

export const logout = () => dispatch => {
    dispatch(logoutRequest());
    return axios('/logout',{
        method: 'GET',
        headers: authHeader()
    })
    .then(response => {
        dispatch(logoutSuccess(response.data));
        localStorage.removeItem('e_3235');
        dispatch(push('/login'));
    })
    .catch(error => {
        dispatch(logoutFailure(error.response.data));
        localStorage.removeItem('e_3235');
        dispatch(push('/login'));
    });
};

export const USER_ACTIVATION_REQUEST = "USER_ACTIVATION_REQUEST";
export const USER_ACTIVATION_SUCCESS = "USER_ACTIVATION_SUCCESS";
export const USER_ACTIVATION_FAILURE = "USER_ACTIVATION_FAILURE";

const userActivationRequest = () => ({
    type: USER_ACTIVATION_REQUEST
});

const userActivationFailure = (payload) => ({
    type: USER_ACTIVATION_FAILURE,
    payload
});

const userActivationSuccess = (payload) => ({
    type: USER_ACTIVATION_SUCCESS,
    payload
});

export const userActivation = ( hashid ) => dispatch => {
    dispatch(userActivationRequest());
    return axios(`/activate/${hashid}`, {
        method: 'POST'
    })
        .then(response => {
            dispatch(userActivationSuccess(response.data));
            if (response.data.token) {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('e_3235', JSON.stringify(response.data.token));
                dispatch(push('/application'));
            }
            return response.data;
        }).catch(error => {
            dispatch(userActivationFailure(error.response.data));
            return error.response.data;
        });
};

export const SEND_FORGOT_PASSWORD_EMAIL_REQUEST = "SEND_FORGOT_PASSWORD_EMAIL_REQUEST";
export const SEND_FORGOT_PASSWORD_EMAIL_SUCCESS = "SEND_FORGOT_PASSWORD_EMAIL_SUCCESS";
export const SEND_FORGOT_PASSWORD_EMAIL_FAILURE = "SEND_FORGOT_PASSWORD_EMAIL_FAILURE";

const sendForgotPasswordEmailRequest = () => ({
    type: SEND_FORGOT_PASSWORD_EMAIL_REQUEST
});

// const sendForgotPasswordEmailFailure = (payload) => ({
//     type: SEND_FORGOT_PASSWORD_EMAIL_FAILURE,
//     payload
// });

const sendForgotPasswordEmailSuccess = (payload) => ({
    type: SEND_FORGOT_PASSWORD_EMAIL_SUCCESS,
    payload
});

export const sendForgotPasswordEmail = (email) => dispatch => {
    dispatch(sendForgotPasswordEmailRequest());
    return axios('/forgot_password/email', {
        method: 'POST',
        data: {
            email
        }
    }).then(response => {
        dispatch(sendForgotPasswordEmailSuccess(response.data));
        return response.data.email;
    });
};

export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
export const CHANGE_PASSWORD_FAILURE = "CHANGE_PASSWORD_FAILURE";

const changePasswordRequest = () => ({
    type: CHANGE_PASSWORD_REQUEST
});

const changePasswordFailure = (payload) => ({
    type: CHANGE_PASSWORD_SUCCESS,
    payload
});

const changePasswordSuccess = (payload) => ({
    type: CHANGE_PASSWORD_FAILURE,
    payload
});

export const changePassword = (data) => dispatch => {
    dispatch(changePasswordRequest());
    return axios('/forgot_password', {
        method: 'POST',
        data
    }).then(response => {
        dispatch(changePasswordSuccess(response.data));
        return response.data;
    }).catch(error => {
        const { data } = error.response;
        dispatch(changePasswordFailure(data));
        if (data.hasOwnProperty('error_code')) {
            if ( data.error_code === 'INVALID' ) {
                throw new SubmissionError({
                    _error: 'The code is invalid or has expired.'
                });
            }
        } else {
            throw new SubmissionError({
                _error: data.message
            })
        }
        return data;
    })
};



// WEBPACK FOOTER //
// ./src/actions/auth.js